import $ from 'jquery';

/**
 * Create filter index
 */
export default class Query {

  constructor(filters = []) {
    this.filters = filters;
    this.index = {};
    this.updateIndex();

    this.popped = ('state' in window.history && window.history.state !== null);
    this.initialURL = location.href;

    window.addEventListener('popstate', (event) => {
        if (event.state) {
            this.onPopState(event)
        }
    }, false);

    // Enter key
    $(document).keypress(function(e) {
      if(e.which == 13) {
        // enter pressed
        if( $(".wjp-jobs-filter-submit").length >= 1 ) {
          $(".wjp-jobs-filter-submit").trigger('click');
        }
      }
    });

    $(".wjp-jobs").find('input.wjp-jobs-filter-submit').on('click', (ev) => {
      ev.preventDefault();
      this.updateQuery();
    });

    /**
		 * Set go back cookie for back button (only on the job archive page)
		 */
		window.WJP.lastPage = Cookies.get('last-page');
		window.WJP.lastPageBody = Cookies.get('last-page-body');

		Cookies.set('last-page', window.location.href);
		Cookies.set('last-page-body', $("body").attr("class") );

    /**
		 * Make use of the cookie in the backbutton
		 */
		$("body").on('click', '.wjp-back-button', function(ev) {
			if( window.WJP.lastPage && window.WJP.lastPageBody ) {
				// Check if the last page class is what the button wants

				if( window.WJP.lastPageBody.indexOf( $(this).data('back-to')) > -1 ) {
					ev.preventDefault();

					if (history.length > 1) {
						history.go(-1);
					} else {
						window.location.href = window.WJP.lastPage;
					}
				}
			}
		});

    $.messages.on('FILTER/VALUE_CHANGED', (action) => {
      if(!action.sender.standalone) {
        setTimeout(() => {
          this.updateQuery(action.key, action.value, action.sender);
        }, 1);
      }
    });
  }

  // Wat te doen bij meerdere dezelfde soort filters?
  // originFilter wordt nu meegestuurd, kan ik ook zien welke filter dit precies is?
  // Hoe gaan we om met het verschil tussen filters die meerdere values ondersteunen en filters die dat niet ondersteunen.
  updateQuery(key, slug, originFilter) {
    // Set all similar filter to the same value
    // This will, unfortunately, call this callback again
    // So we need to set a let syncingFields to prevent a endless loop
    if( this.syncingFields ) return;

    this.syncingFields = false;

    this.updateIndex();

    // The map is active so it needs to be updated
    let geoFilters = window.WJP.query.getFilters('geo');
    let isGeoView = false;
    for(let i = 0; i < geoFilters.length; i++ ) {
      if(geoFilters[i].isMap && geoFilters[i].isMap()) {
        geoFilters[i].update();
        isGeoView = true;
      }
    }

    if($("[data-view='job/list']").length) {
      // If the origin of this request isn't the pagination.
      // The paged need to be unset
      if(key !== "paged") {
        this.index['paged'] = false;
      } else {
        // Go to the top of the page
        // When navigating
        $('html, body').animate({
                scrollTop: $("[data-view='job/list']").offset().top - 100
        }, 250);
      }

      $("[data-view='job/list']").html(window.WJP.reloadingHTML);
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.doAjaxRequest();
      }, 300);
    } else {
      // Klikken op de zoekfunctie van de homepage. De originFilter is blijkbaar undefined?
      // Dropdowns moeten niet leiden tot een directe zoekacties vandaar deze if.
      if (typeof originFilter === 'undefined') {
        let urls = this.createUrl(window.location.origin + "/vacatures");
  
        window.location.href = urls.url;
        // this.pushState(urls.url);

      }
    }
  }

  createUrl(customUrl) {
    let request = this.createRequest();
    this.lastRequest = request;

    // let nocache = new Date().getTime();
    let url = URI( (customUrl)? customUrl : $("[data-view='job/list']").data('ajax-endpoint') );
    // debugger;
    let srequest = URI.parseQuery(request);

    url.addSearch( srequest );
    url.normalize();

    let cacheUrl = URI(url);
    cacheUrl.addSearch( "nocache" );

    return {
      url: url.toString(),
      cacheUrl: cacheUrl.toString(),
      request: request
    }
  }

  pushState(url) {
    if ( history.pushState ) {
      history.pushState(url, "", url);
    }
  }

  doAjaxRequest(customUrl, pushState = true) {
    let urls = this.createUrl(customUrl);

    let ajax = $.get( urls.cacheUrl );

    if(customUrl) {
      this.setFilterValues(customUrl);
    }

    ajax.done( (response) => {
      pushState && this.pushState(urls.url);

      if(this.lastRequest === urls.request) {
        // console.log("Update", request);
        $("[data-view='job/list']").html(response);
        window.WJP.fixSidebarPosition(250);
      } else {
        // console.log("Waste", request);
      }
      this.isBusy = false;
    });

    this.isBusy = true;
  }

  setFilterValues(customUrl) {
    // console.log(customUrl);
    let url = URI(customUrl);
    let queryFilters = URI.parseQuery(url.query())

    this.syncingFields = true;
    // First reset all filters
    this.resetFilters();

    for (let key in queryFilters) {
      if (queryFilters.hasOwnProperty(key)) {
        let queryFilter = queryFilters[key];
        let filters = window.WJP.query.getFilters(key);

        for (let i = 0; i < filters.length; i++) {
          let filter = filters[i];
          filter.setValue(queryFilter);
        }
      }
    }
    this.syncingFields = false;
  }

  resetFilters() {
    let filters = window.WJP.query.getFilters();

    for (let i = 0; i < filters.length; i++) {
      let filter = filters[i];
      filter.setValue(false);
    }
  }

  onPopState(event) {
    let initialPop = !this.popped && location.href == this.initialURL;
    this.popped = true;
    if ( initialPop ) return;

    let state = event.state;
    if (!state){
        state=history.state; // FF
    }

    console.log('windowstte', state);

    if (state){
        // let title= state.title;
        this.doAjaxRequest(document.location.href, false);
    }
    else {
      window.location.reload();
    }
  }

  updateIndex() {
    for(let i=0; i < this.filters.length; i++) {
      let filter = this.filters[i];

      if(!filter.standalone && filter.isActive) {
        if(filter.getValue()) {
          this.index[filter.getKey()] = filter.getValue();
        } else {
          delete this.index[filter.getKey()];
        }
      }
    }
  }

  setFilters(filters) {
    this.filters = [];

    for(let i=0; i < filters.length; i++) {
      let filter = filters[i];
      // Check if the filter is properly defined and available
      if( typeof filter.filterType !== "undefined" ) {
        this.filters.push(filter);
      }
    }

    this.updateIndex();
  }

  getFilters(key) {
    if( typeof key === 'undefined' ) {
      return this.filters;
    } else {
      let returnValue = [];

      for(let i=0; i < this.filters.length; i++) {
        let filter = this.filters[i];

        if(filter.getKey() === key) {
          returnValue.push(filter);
        }
      }

      return returnValue;
    }
  }

  createRequest() {
    let strings = [];

    // this.updateIndex();

    for (let key in this.index) {
       let value = this.index[key];
       if(this.index.hasOwnProperty(key)){
           let string = "";
           value = (typeof value === 'string') ? [ value ] : value;
           if(typeof value[0] !== "undefined") {
              string += key + "=" + value.join('+');
              strings.push(string);
           }
       }
    }
    let output = strings.join("&");
    return (output) ? output : "";
  }
}



/** WEBPACK FOOTER **
 ** ../assets/js/system/Query.js
 **/